import React, { FC, useEffect, useRef } from 'react';
import { renderAsync } from 'docx-preview';
import './styles.css';

interface IDocViewer {
  source: string;
}

const DocViewer: FC<IDocViewer> = ({ source }) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const load = async () => {
      const response = await fetch(source); // public folder
      const arrayBuffer = await response.arrayBuffer();

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      renderAsync(arrayBuffer, ref.current, null, { className: 'docx' });
    };

    if (source) {
      load();
    }
  }, []);

  return <div ref={ref} />;
};

export default DocViewer;
